import { FormInstance, message } from 'antd';
import { ApiService } from 'service/api/apiService';
import { genreApiService } from 'service/api/genreApiService';
import { GenreInterface } from 'type/genreType';

class GenreService {
  constructor(private apiService: ApiService<GenreInterface>) {}

  public async createGenre(
    form: FormInstance,
    customData?: Partial<GenreInterface>
  ): Promise<GenreInterface> {
    try {
      const genre = { ...form.getFieldsValue(), ...customData };
      // Legacy name field: use lowercase if it exists
      if (genre.name) {
        genre.name = genre.name.toLowerCase();
      }
      // If i18n_name exists but name doesn't, use i18n_name.ko
      if (genre.i18n_name?.ko && !genre.name) {
        genre.name = genre.i18n_name.ko.toLowerCase();
      }
      if (genre.slug) {
        genre.slug = genre.slug.toLowerCase();
      }
      // Ensure i18n field is included even if it's an empty object
      if (!genre.i18n_name) {
        genre.i18n_name = {};
      }
      return await this.apiService.create(genre);
    } catch (error) {
      message.error('Failed to create : ' + error);
      throw error;
    }
  }

  public async updateGenre(
    id: number,
    form: FormInstance,
    customData?: Partial<GenreInterface>
  ): Promise<GenreInterface> {
    try {
      const genre = { ...form.getFieldsValue(), ...customData };
      // Legacy name field: use lowercase if it exists
      if (genre.name) {
        genre.name = genre.name.toLowerCase();
      }
      // If i18n_name exists but name doesn't, use i18n_name.ko
      if (genre.i18n_name?.ko && !genre.name) {
        genre.name = genre.i18n_name.ko.toLowerCase();
      }
      if (genre.slug) {
        genre.slug = genre.slug.toLowerCase();
      }
      // Ensure i18n field is included even if it's an empty object
      if (!genre.i18n_name) {
        genre.i18n_name = {};
      }
      return await this.apiService.update(id, genre);
    } catch (error) {
      message.error('Failed to update : ' + error);
      throw error;
    }
  }
}

export const genreService = new GenreService(genreApiService);
